import React, { useState } from "react";
import { Container, useMediaQuery, Grid, Box } from "@mui/material";
import Jackpot from "./Jackpot";
import BuyCON from "./BuyCON";
import Overview from "./Overview";

import mc1 from "./mAssets/c1.svg";
import mf1 from "./mAssets/f1.svg";
import mf2 from "./mAssets/f2.svg";
import RefrelSystem from "./RefrelSystem";

function Dashbord({ totalNode1, totalNode2, totalNode3, userNodesData, init,setConValue,ConValue }) {
  const mobile = useMediaQuery("(max-width:1050px)");

  return (
    <div
      style={{
        background:
          "radial-gradient(68.29% 68.29% at 50% 50%, #73246C 0%, #1A103B 100%)",
        backgroundSize: "cover",
        width: "100%",
        paddingTop: "75px",
        paddingBottom: "75px",
        zIndex: "-5",

        overflowX: "hidden",
      }}
    >
      <Container maxWidth="xl">
        {/* m Animattions  */}

        {mobile ? (
          <>
            <Box sx={{ position: "relative" }}>
              {/* mf1   */}
              <img
                className="updown"
                src={mf1}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-10px",
                  marginLeft: "40px",
                }}
                alt=""
              />

              {/* mc1   */}
              <img
                src={mc1}
                className="rotate"
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-10px",
                  marginLeft: "210px",
                }}
                alt=""
              />
              {/* mf2   */}
              <img
                className="rotate"
                src={mf2}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "20px",
                  marginLeft: "210px",
                }}
                alt=""
              />
            </Box>
          </>
        ) : (
          <></>
        )}
        <Grid container spacing={3}>
          <Grid item xs={mobile ? 12 : 6}>
            <Jackpot
              initNodes={init}
              totalNode1={totalNode1}
              totalNode2={totalNode2}
              totalNode3={totalNode3}
              setConValue={setConValue}
            />
          </Grid>
          <Grid item xs={mobile ? 12 : 6}>
            <BuyCON />
          </Grid>
        </Grid>
        <Overview
          totalNode1={totalNode1}
          totalNode2={totalNode2}
          totalNode3={totalNode3}
          userNodesData={userNodesData}
          init={init}
          ConValue={ConValue}
        />
        <RefrelSystem />
      </Container>
    </div>
  );
}

export default Dashbord;
